var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row full-width items-center justify-center q-pt-xs cursor-pointer",on:{"click":_vm.openAttach}},[_c('div',{staticClass:"col-auto img-preview",staticStyle:{"width":"65px","height":"84px","position":"relative"}},[_c(_vm.attachIcon,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }